import { render } from "./EwalletSystem.vue?vue&type=template&id=1d5d4826&scoped=true"
import script from "./EwalletSystem.vue?vue&type=script&lang=js"
export * from "./EwalletSystem.vue?vue&type=script&lang=js"

import "./EwalletSystem.vue?vue&type=style&index=0&id=1d5d4826&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d5d4826"]])

export default __exports__